import api from '@/api/mintAgreements';

const state = {
  plan: null,
  pending: [],
  history: [],
  current: null,
  loading: false,
  notifications: { count: 0, items: [] },
};

const getters = {
  plan: (state) => state.plan,
  pendingAgreements: (state) => state.pending,
  paidOrCancelledAgreements: (state) => state.history,
  current: (state) => state.current,
  loading: (state) => state.loading,
  notifications: (state) => state.notifications,
  notificationCount: (state) => (state.notifications && state.notifications.count) || 0,
};

const actions = {
  async getUpcomingPlan({ commit }, { from, to } = {}) {
    commit('setLoading', true);
    try {
      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;
      const result = await api.getUpcomingPlan(params);
      commit('setPlan', result.data);
      return result.data;
    } finally {
      commit('setLoading', false);
    }
  },
  async getPending({ commit }) {
    commit('setLoading', true);
    try {
      const result = await api.getList({ status: 0 });
      commit('setPending', result.data);
      return result.data;
    } finally {
      commit('setLoading', false);
    }
  },
  async getHistory({ commit }, filters = {}) {
    commit('setLoading', true);
    try {
      const result = await api.getList(filters);
      commit('setHistory', result.data);
      return result.data;
    } finally {
      commit('setLoading', false);
    }
  },
  async get({ commit }, id) {
    const result = await api.get(id);
    commit('setCurrent', result.data);
    return result.data;
  },
  async createAgreement({ commit }, payload) {
    const result = await api.create(payload);
    commit('addAgreement', result.data);
    return result.data;
  },
  async updateAgreement({ commit }, { id, payload }) {
    const result = await api.update(id, payload);
    commit('updateAgreement', result.data);
    return result.data;
  },
  async markPaid({ commit }, { id, paidAt, cashAccountId }) {
    const result = await api.markPaid(id, paidAt, cashAccountId);
    commit('updateAgreement', result.data);
    return result.data;
  },
  async partialPay(_ctx, { id, payload }) {
    const result = await api.partialPay(id, payload);
    return result.data;
  },
  async getChain(_ctx, id) {
    const result = await api.getChain(id);
    return result.data || [];
  },
  async cancelAgreement({ commit }, id) {
    await api.cancel(id);
    commit('removeAgreement', id);
  },
  async getNotifications({ commit }, daysAhead = 1) {
    try {
      const result = await api.getNotifications(daysAhead);
      commit('setNotifications', result.data);
      return result.data;
    } catch (e) {
      commit('setNotifications', { count: 0, items: [] });
      return null;
    }
  },
};

const mutations = {
  setPlan(state, plan) {
    state.plan = plan;
  },
  setPending(state, agreements) {
    state.pending = agreements || [];
  },
  setHistory(state, agreements) {
    state.history = agreements || [];
  },
  addAgreement(state, agreement) {
    if (!agreement) return;
    if (agreement.status === 0) state.pending.unshift(agreement);
    else state.history.unshift(agreement);
  },
  updateAgreement(state, agreement) {
    if (!agreement) return;
    const pi = state.pending.findIndex((a) => a.id === agreement.id);
    if (pi !== -1) {
      if (agreement.status === 0) state.pending.splice(pi, 1, agreement);
      else state.pending.splice(pi, 1);
    } else if (agreement.status === 0) {
      state.pending.unshift(agreement);
    }
    const hi = state.history.findIndex((a) => a.id === agreement.id);
    if (hi !== -1) {
      if (agreement.status !== 0) state.history.splice(hi, 1, agreement);
      else state.history.splice(hi, 1);
    }
  },
  removeAgreement(state, id) {
    const pi = state.pending.findIndex((a) => a.id === id);
    if (pi !== -1) state.pending.splice(pi, 1);
    const hi = state.history.findIndex((a) => a.id === id);
    if (hi !== -1) state.history.splice(hi, 1);
  },
  setCurrent(state, current) {
    state.current = current;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setNotifications(state, payload) {
    state.notifications = payload || { count: 0, items: [] };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
